// extracted by mini-css-extract-plugin
module.exports = {"dataContainer":"MufLT4Hddx0kdkiJ8vSS8A==","title":"_17SpTrzosk1vo8X4XE4aOw==","button":"mRN82awbxQ4PcNoDq50Ydg==","cardName":"hlF7aFFsyWHxJ6PTsTL6Wg=="};